import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static get targets() {
    return [ 'companyId', 'contents', 'generateInputs' ]
  }

  connect() {
    this.select2(this.companyIdTarget);
  }

  update() {
    var selected_ids = this.selectedCompanyIds();

    if (selected_ids.length == 0) {
      this.element.querySelectorAll('[data-company-id]').forEach(function(element) {
        jQuery(element).show();
      });
    } else {
      this.element.querySelectorAll('[data-company-id]').forEach(function(element) {
        jQuery(element).hide();
      });

      for (var i = 0; i < selected_ids.length; i++) {
        var element = this.element.querySelector('[data-company-id="' + selected_ids[i] + '"]');
        if (element) {
          jQuery(element).show();
        }
      }
    }

    this.syncQueryString(selected_ids);
    this.syncGenerateInputs(selected_ids);
  }

  selectedCompanyIds() {
    var selected_ids = [];
    var selected_options = this.companyIdTarget.selectedOptions;

    for (var i = 0; i < selected_options.length; i++) {
      if (selected_options[i].value.length > 0) {
        selected_ids.push(selected_options[i].value);
      }
    }

    return selected_ids;
  }

  syncQueryString(selected_ids) {
    var url = new URL(window.location.href);

    url.searchParams.delete('document_company_id');
    url.searchParams.delete('document_company_id[]');

    for (var i = 0; i < selected_ids.length; i++) {
      url.searchParams.append('document_company_id[]', selected_ids[i]);
    }

    window.history.replaceState({}, '', url.toString());
  }

  syncGenerateInputs(selected_ids) {
    if (!this.hasGenerateInputsTarget) {
      return;
    }

    while (this.generateInputsTarget.firstChild) {
      this.generateInputsTarget.removeChild(this.generateInputsTarget.firstChild);
    }

    for (var i = 0; i < selected_ids.length; i++) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'document_company_id[]';
      input.value = selected_ids[i];
      this.generateInputsTarget.appendChild(input);
    }
  }

  select2(target) {
    let controller = this;
    let $target = jQuery(target);

    /* FIXME terrible hack to prevent empty select2 */
    setTimeout(function() {
      $target.select2(select2_options);
      /* convert select2 events to native change event
      which stimulus can handle */
      $target.on('select2:select select2:unselect', function() {
        target.dispatchEvent(new Event('change', { bubbles: true }))
      });

      controller.update();
    }, 100);
  }
}
